import { Suspense } from "react";
import { useShallow } from "zustand/react/shallow";

import { Alert } from "@organisms/alert/alert";
import { useAlertStore } from "@organisms/alert/alertStore";

export function AlertContainer() {
  const alertProps = useAlertStore(useShallow((state) => state.alertProps));

  return (
    <Suspense>
      <Alert {...alertProps} />
    </Suspense>
  );
}
